export const UserCreationMode = {
    STAY: 0,
    CONTINUE: 1,
};

Object.freeze(UserCreationMode);